import { apiCalificacionAsignarV3, apiCalificacionObtenerAsistencias, apiCalificacionObtenerPendientes } from "../API";
import { _APP_DATA } from "../AppData";
import { IApiResult, ICalificacionPendiente } from "../models/Entities";
import { RequestData } from "../utils/RequestData";

export function _SvCalificacionObtenerPendientes() {
    const params = {
        IdGrupo: _APP_DATA.userData.IdGrupo,
    }

    return new Promise<ICalificacionPendiente[]>((resolve, reject) => {
        new RequestData<IApiResult<ICalificacionPendiente[]>>(apiCalificacionObtenerPendientes)
            .Params(params)
            .Completion((response, error) => {
                let resultData = response?.Datos || [];

                if (error) {
                    console.log(error.name, error.message);
                    reject(error);
                    return
                }
                resolve(resultData);
            })
            .Get();
    })
}

type IAsignarCalificacionParam = Partial<Pick<ICalificacionPendiente, "Id" | "IdAsignacion">> & {
    Calificacion: string;
    Observacion: string;
    FechaEval: string;
}
type IAsignarCalificacionResponse = {
    Resultado: number
    IndexFechasInasistencia?: number[]
}
export function _SvCalificacionAsignar(exTemporal: boolean, idAlumno: number, calificaciones: IAsignarCalificacionParam[]): Promise<IAsignarCalificacionResponse> {
    const ids: number[] = [];
    const valorCalif: string[] = [];
    const observacion: string[] = [];
    const tipo: number[] = [];
    const fechaEval: string[] = [];
    calificaciones.forEach(d => {
        observacion.push(d.Observacion);
        valorCalif.push(d.Calificacion);
        fechaEval.push(d.FechaEval);
        if (d.Id == 0) {
            ids.push(d.IdAsignacion);
            tipo.push(9); // ESTILO LIBRE
        } else {
            ids.push(d.Id);
            tipo.push(0);
        }
    })
    const params = {
        IdUsuario: _APP_DATA.userData.IdUsuario,
        IdGrupo: _APP_DATA.userData.IdGrupo,
        IdOrganizacion: _APP_DATA.userData.IdOrganizacion,
        IdAlumno: idAlumno,
        ExTemporal: exTemporal,
        Ids: ids,
        ValorCalificacion: valorCalif,
        Observacion: observacion,
        Tipo: tipo,
        FechaEval: fechaEval,
    }
    return new Promise<IAsignarCalificacionResponse>((resolve, reject) => {
        new RequestData<IApiResult<undefined>>(apiCalificacionAsignarV3)
            .Params(params)
            .Completion((response, error) => {
                if (error) {
                    reject(error);
                    return;
                }
                resolve({
                    Resultado: (response?.Resultado || -11),
                    IndexFechasInasistencia: (response as any)?.IndexFechasInasistencia,
                });
            })
            .Post();
    })
}

export function _SvCalificacionObtenerAsistencias(idAlumno: number, inicio: Date, fin: Date) {
    return new Promise<IApiResult<string[]>>((resolve, reject) => {
        const params = {
            "IdAlumno": idAlumno,
            "IdGrupo": _APP_DATA.userData.IdGrupo,
            "IdOrganizacion": _APP_DATA.userData.IdOrganizacion,
            "Inicio": inicio.toISOString(),
            "Fin": fin.toISOString(),
        }
        new RequestData<IApiResult<string[]>>(apiCalificacionObtenerAsistencias)
            .Params(params)
            .Completion((response, error) => {
                if (error) {
                    reject(error)
                    return
                }
                resolve(response || <IApiResult<string[]>>{ Resultado: -11 })
            })
            .Get()
    })
}